import { AxiosResponse } from "axios";
import { all, call, put, takeEvery } from "redux-saga/effects";
import api from "../../api";
import Endpoint from "../../shared/endpoints";
import incomeShareConstants from "../constants/incomeShareConstants";

const addIncomeShare = (payload: any) => {
  return api.post(Endpoint.createIncomeShare, payload);
};

const editIncomeShare = (payload: any) =>
  api.put(`${Endpoint.editIncomeShare}/${payload.id}/`, payload.body);

const addSpecificIncomeShare = (payload: any) => {
  return api.post(Endpoint.addSpecificIncomeShare, payload);
};

const getSpecificIncomeShare = (payload: any) =>
  api.get(Endpoint.getSpecificIncomeShare, payload);

const getIncomeShare = (payload: any) =>
  api.get(`${Endpoint.retrieveIncomeShare}/${payload.id}`);

function* getIncomeShareAsync(action: any) {
  try {
    const response: AxiosResponse = yield call(getIncomeShare, action.payload);
    yield put({
      type: incomeShareConstants.GET_INCOME_SHARE_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({ type: incomeShareConstants.GET_INCOME_SHARE_FAILURE, err: e });
  }
}

function* createIncomeShare(action: any) {
  try {
    const response: AxiosResponse = yield call(addIncomeShare, action.payload);
    yield put({
      type: incomeShareConstants.ADD_INCOME_SHARE_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({ type: incomeShareConstants.ADD_INCOME_SHARE_FAILURE, err: e });
  }
}

function* editIncomeShareAsync(action: any) {
  try {
    const response: AxiosResponse = yield call(editIncomeShare, action.payload);
    yield put({
      type: incomeShareConstants.EDIT_INCOME_SHARE_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({ type: incomeShareConstants.EDIT_INCOME_SHARE_FAILURE, err: e });
  }
}

function* addSpecificIncomeShareAsync(action: any) {
  try {
    const response: AxiosResponse = yield call(
      addSpecificIncomeShare,
      action.payload,
    );
    yield put({
      type: incomeShareConstants.SPECIFIC_INCOME_SHARE_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({
      type: incomeShareConstants.SPECIFIC_INCOME_SHARE_FAILURE,
      err: e,
    });
  }
}

function* getSpecificIncomeShareAsync(action: any) {
  try {
    const response: AxiosResponse = yield call(
      getSpecificIncomeShare,
      action.payload,
    );
    yield put({
      type: incomeShareConstants.GET_SPECIFIC_INCOME_SUCCESS,
      payload: response,
    });
  } catch (e) {
    yield put({
      type: incomeShareConstants.GET_SPECIFIC_INCOME_FAILURE,
      err: e,
    });
  }
}

function* incomeShareSaga() {
  yield all([
    takeEvery(
      incomeShareConstants.GET_INCOME_SHARE_REQUEST,
      getIncomeShareAsync,
    ),
  ]);
  yield all([
    takeEvery(incomeShareConstants.ADD_INCOME_SHARE_REQ, createIncomeShare),
  ]);
  yield all([
    takeEvery(
      incomeShareConstants.EDIT_INCOME_SHARE_REQUEST,
      editIncomeShareAsync,
    ),
  ]);
  yield all([
    takeEvery(
      incomeShareConstants.SPECIFIC_INCOME_SHARE_REQUEST,
      addSpecificIncomeShareAsync,
    ),
  ]);
  yield all([
    takeEvery(
      incomeShareConstants.GET_SPECIFIC_INCOME_REQUEST,
      getSpecificIncomeShareAsync,
    ),
  ]);
}

export default incomeShareSaga;
